<template>
  <div>
      <b-row>
          <b-col sm="6" lg="3">
              <b-card no-body class="bg-primary">
                  <b-card-body class="pb-0">
                      <h3 class="mb-0">{{ totalProducts }}</h3>
                      <p>Total Products</p>
                  </b-card-body>
              </b-card>
          </b-col>
          <b-col sm="6" lg="3">
              <b-card no-body class="bg-info">
                  <b-card-body class="pb-0">
                      <h3 class="mb-0">{{ lowStockProducts }}</h3>
                      <p>Low Stock Products</p>
                  </b-card-body>
              </b-card>
          </b-col>
          <b-col sm="6" lg="3">
              <b-card no-body class="bg-warning">
                  <b-card-body class="pb-0">
                      <h3 class="mb-0">{{ outOfStockProducts }}</h3>
                      <p>Out of Stock Products</p>
                  </b-card-body>
              </b-card>
          </b-col>
          <b-col sm="6" lg="3">
              <b-card no-body class="bg-danger">
                  <b-card-body class="pb-0">
                      <h3 class="mb-0">{{ zeroStockProducts }}</h3>
                      <p>Zero Stock Products</p>
                  </b-card-body>
              </b-card>
          </b-col>
      </b-row>

      <b-row>
          <b-col sm="12" lg="6" xl="4">
              <b-card :class="{'fullscreen': fullscreenCard === 'barcodeScan'}" header="패키징 별 바코드 발행 대비 스캔 수">
                  <template v-slot:header>
                      <div class="d-flex justify-content-between align-items-center">
                          <span>패키징 별 바코드 발행 대비 스캔 수</span>
                          <b-button @click="toggleFullscreen('barcodeScan')" size="sm" variant="link" class="p-0">
                              <i :class="fullscreenCard === 'barcodeScan' ? 'fas fa-compress' : 'fas fa-expand'"></i>
                          </b-button>
                      </div>
                  </template>
                  <div class="chart-wrapper">
                      <DateFilter v-model="barcodeScanFilter" @input="fetchBarcodeScanData" />
                      <LineExample :chartData="barcodeScanData" />
                  </div>
              </b-card>
          </b-col>

          <b-col sm="12" lg="6" xl="4">
              <b-card :class="{'fullscreen': fullscreenCard === 'averageRemainingStockProducts'}" header="이벤트 타입별 바코드 발행 수">
                  <template v-slot:header>
                      <div class="d-flex justify-content-between align-items-center">
                          <span>재고량</span>
                          <b-button @click="toggleFullscreen('averageRemainingStockProducts')" size="sm" variant="link" class="p-0">
                              <i :class="fullscreenCard === 'averageRemainingStockProducts' ? 'fas fa-compress' : 'fas fa-expand'"></i>
                          </b-button>
                      </div>
                  </template>
                  <div class="chart-wrapper">
                      <DateFilter v-model="averageRemainingStockProductsFilter" @input="fetchAverageRemainingStockProductsData" />
                      <BarChart :chartData="averageRemainingStockProductsData" />
                  </div>
              </b-card>
          </b-col>

          <b-col sm="12" lg="6" xl="4">
              <b-card :class="{'fullscreen': fullscreenCard === 'inOutStock'}" header="입출고">
                  <template v-slot:header>
                      <div class="d-flex justify-content-between align-items-center">
                          <span>입출고</span>
                          <b-button @click="toggleFullscreen('inOutStock')" size="sm" variant="link" class="p-0">
                              <i :class="fullscreenCard === 'inOutStock' ? 'fas fa-compress' : 'fas fa-expand'"></i>
                          </b-button>
                      </div>
                  </template>
                  <div class="chart-wrapper">
                      <DateFilter v-model="inOutStockFilter" @input="fetchInOutStockData" />
                      <LineChart1 :chartData="inOutStockData" />
                  </div>
              </b-card>
          </b-col>
          
          <b-col sm="12" lg="6" xl="4">
              <b-card :class="{'fullscreen': fullscreenCard === 'thresholdApproaching'}" header="임계 하한점에 다다른 제품">
                  <template v-slot:header>
                      <div class="d-flex justify-content-between align-items-center">
                          <span>임계 하한점에 다다른 제품 (Low Stock Products)</span>
                          <b-button @click="toggleFullscreen('thresholdApproaching')" size="sm" variant="link" class="p-0">
                              <i :class="fullscreenCard === 'thresholdApproaching' ? 'fas fa-compress' : 'fas fa-expand'"></i>
                          </b-button>
                      </div>
                  </template>
                  <div class="chart-wrapper">
                      <DateFilter v-model="thresholdApproachingFilter" @input="fetchThresholdApproachingData" />
                      <LineChart4 :chartData="thresholdApproachingProductsData" />
                  </div>
              </b-card>
          </b-col>

          <b-col sm="12" lg="6" xl="4">
              <b-card :class="{'fullscreen': fullscreenCard === 'thresholdReached'}" header="임계 하한점에 진입한 제품">
                  <template v-slot:header>
                      <div class="d-flex justify-content-between align-items-center">
                          <span>임계 하한점에 진입한 제품 (Out of Stock Products)</span>
                          <b-button @click="toggleFullscreen('thresholdReached')" size="sm" variant="link" class="p-0">
                              <i :class="fullscreenCard === 'thresholdReached' ? 'fas fa-compress' : 'fas fa-expand'"></i>
                          </b-button>
                      </div>
                  </template>
                  <div class="chart-wrapper">
                      <DateFilter v-model="thresholdReachedFilter" @input="fetchThresholdReachedData" />
                      <LineChart4 :chartData="thresholdReachedProductsData" />
                  </div>
              </b-card>
          </b-col>

          <b-col sm="12" lg="6" xl="4">
              <b-card :class="{'fullscreen': fullscreenCard === 'outOfStockProducts'}" header="재고없음">
                  <template v-slot:header>
                      <div class="d-flex justify-content-between align-items-center">
                          <span>재고없음 (Zero Stock Products)</span>
                          <b-button @click="toggleFullscreen('outOfStockProducts')" size="sm" variant="link" class="p-0">
                              <i :class="fullscreenCard === 'outOfStockProducts' ? 'fas fa-compress' : 'fas fa-expand'"></i>
                          </b-button>
                      </div>
                  </template>
                  <div class="chart-wrapper">
                      <DateFilter v-model="outOfStockProductsFilter" @input="fetchOutOfStockProductsData" />
                      <LineChart4 :chartData="outOfStockProductsDailyData" />
                  </div>
              </b-card>
          </b-col>
      </b-row>
  </div>
</template>
  
  <script>
  import { 
    fetchTotalProducts, 
    fetchLowStockProducts, 
    fetchOutOfStockProducts, 
    fetchZeroStockProducts, 
    fetchBarcodeScanData, 
    fetchThresholdApproachingData, 
    fetchOutOfStockProductsData, 
    fetchAverageRemainingStockProductsData, 
    fetchThresholdReachedData, 
    fetchInOutStockData 
  } from '@/api/api.js';
  
  import '@fortawesome/fontawesome-free/css/all.css';
  import LineChart1 from './charts/LineChart1.vue';
  import LineChart2 from './charts/LineChart2.vue';
  import LineChart3 from './charts/LineChart3.vue';
  import LineChart4 from './charts/LineChart4.vue';
  import LineExample from './charts/LineExample.vue';
  import PieExample from './charts/PieExample.vue';
  import BarChart from './charts/BarChart.vue';
  import DateFilter from '@/components/DateFilter.vue';
  import DateRangeFilter from '@/components/DateRangeFilter.vue';
  
  export default {
    components: {
      LineChart1,
      LineChart2,
      LineChart3,
      LineChart4,
      LineExample,
      PieExample,
      BarChart,
      DateFilter,
      DateRangeFilter
    },
    async beforeMount() {
      this.setDefaultFilter();
      await this.fetchData();
    },
    data() {
      return {
        fullscreenCard: null,
        totalProducts: 0,
        lowStockProducts: 0,
        outOfStockProducts: 0,
        zeroStockProducts: 0,
        barcodeScanData: {},
        thresholdApproachingProductsData: {},
        outOfStockProductsDailyData: {},
        averageRemainingStockProductsData: {},
        thresholdReachedProductsData: {},
        inOutStockData: {},
        barcodeScanFilter: { date: '', days: 7 },
        thresholdApproachingFilter: { date: '', days: 7 },
        outOfStockProductsFilter: { date: '', days: 7 },
        averageRemainingStockProductsFilter: { date: '', days: 7 },
        thresholdReachedFilter: { date: '', days: 7 },
        inOutStockFilter: { date: '', days: 7 },
      }
    },
    methods: {
      setDefaultFilter() {
        const today = new Date().toISOString().split('T')[0];
        this.barcodeScanFilter.date = today;
        this.thresholdApproachingFilter.date = today;
        this.outOfStockProductsFilter.date = today;
        this.averageRemainingStockProductsFilter.date = today;
        this.thresholdReachedFilter.date = today;
        this.inOutStockFilter.date = today;
      },
      toggleFullscreen(card) {
        if (this.fullscreenCard === card) {
          this.fullscreenCard = null;
          document.body.classList.remove('no-scroll');
        } else {
          this.fullscreenCard = card;
          document.body.classList.add('no-scroll');
        }
      },
      async fetchData() {
        try {
          const [
            totalProductsRes,
            lowStockProductsRes,
            outOfStockProductsRes,
            zeroStockProductsRes
          ] = await Promise.all([
            fetchTotalProducts(this.barcodeScanFilter.date, this.barcodeScanFilter.days),
            fetchLowStockProducts(this.thresholdApproachingFilter.date, this.thresholdApproachingFilter.days),
            fetchOutOfStockProducts(this.thresholdReachedFilter.date, this.thresholdReachedFilter.days),
            fetchZeroStockProducts(this.outOfStockProductsFilter.date, this.outOfStockProductsFilter.days)
          ]);
  
          this.totalProducts = totalProductsRes.total || 0;
          this.lowStockProducts = lowStockProductsRes || 0;
          this.outOfStockProducts = outOfStockProductsRes || 0;
          this.zeroStockProducts = zeroStockProductsRes || 0;
  
          await this.fetchBarcodeScanData();
          await this.fetchThresholdApproachingData();
          await this.fetchOutOfStockProductsData();
          await this.fetchAverageRemainingStockProductsData();
          await this.fetchThresholdReachedData();
          await this.fetchInOutStockData();
        } catch (error) {
          console.error('Error fetching data', error);
        }
      },
      async fetchBarcodeScanData() {
        try {
          const barcodeScanRes = await fetchBarcodeScanData(this.barcodeScanFilter.date, this.barcodeScanFilter.days);
          this.barcodeScanData = this.formatChartData(barcodeScanRes);
        } catch (error) {
          console.error('Error fetching barcode scan data', error);
        }
      },
      async fetchThresholdApproachingData() {
        try {
          const thresholdApproachingRes = await fetchThresholdApproachingData(this.thresholdApproachingFilter.date, this.thresholdApproachingFilter.days);
          this.thresholdApproachingProductsData = this.formatChartData(thresholdApproachingRes);
        } catch (error) {
          console.error('Error fetching threshold approaching data', error);
        }
      },
      async fetchOutOfStockProductsData() {
        try {
          const outOfStockProductsRes = await fetchOutOfStockProductsData(this.outOfStockProductsFilter.date, this.outOfStockProductsFilter.days);
          this.outOfStockProductsDailyData = this.formatChartData(outOfStockProductsRes);
          //console.log('11111111111111111111111111111111111111111111111111111111111')
          const low_of_stock_res = await fetchLowStockProducts(this.thresholdApproachingFilter.date, this.thresholdApproachingFilter.days);
          this.lowStockProducts = low_of_stock_res || 0;

          const out_of_stock_res = await fetchOutOfStockProducts(this.thresholdReachedFilter.date, this.thresholdReachedFilter.days);
          this.outOfStockProducts = out_of_stock_res || 0;

          const zero_of_stock_res = await fetchZeroStockProducts(this.outOfStockProductsFilter.date, this.outOfStockProductsFilter.days);
          this.zeroStockProducts = zero_of_stock_res || 0;
          //console.log('11111111111111111111111111111111111111111111111111111111111')
        } catch (error) {
          console.error('Error fetching out of stock products data', error);
        }
      },
      async fetchAverageRemainingStockProductsData() {
        try {
          const averageRemainingStockProductsRes = await fetchAverageRemainingStockProductsData(this.averageRemainingStockProductsFilter.date, this.averageRemainingStockProductsFilter.days);
          this.averageRemainingStockProductsData = this.formatChartData(averageRemainingStockProductsRes);
        } catch (error) {
          console.error('Error fetching barcode event data', error);
        }
      },
      async fetchThresholdReachedData() {
        try {
          const thresholdReachedRes = await fetchThresholdReachedData(this.thresholdReachedFilter.date, this.thresholdReachedFilter.days);
          this.thresholdReachedProductsData = this.formatChartData(thresholdReachedRes);
        } catch (error) {
          console.error('Error fetching threshold reached data', error);
        }
      },
      async fetchInOutStockData() {
        try {
          const inOutStockRes = await fetchInOutStockData(this.inOutStockFilter.date, this.inOutStockFilter.days);
          this.inOutStockData = this.formatChartData(inOutStockRes);
        } catch (error) {
          console.error('Error fetching in/out stock data', error);
        }
      },
      formatChartData(data) {
        return {
          labels: data.labels,
          datasets: data.datasets.map(dataset => ({
            ...dataset,
            backgroundColor: 'rgba(54, 162, 235, 0.5)', // 막대 색상 수정
            borderColor: 'rgba(54, 162, 235, 1)',
            borderWidth: 1,
            tension: 0
          }))
        };
      },
      getRandomColor() {
        const letters = '0123456789ABCDEF';
        let color = '#';
        for (let i = 0; i < 6; i++) {
          color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
      }
    }
  };
  </script>
  
  <style scoped>
  .card-body-custom {
    max-width: 37rem;
    background-color: #ffffff;
  }
  .text-center {
    text-align: center;
  }
  .chart-wrapper {
    height: auto;
  }
  .fullscreen {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 1050; /* Higher than Bootstrap's modal (1040) */
    background: white;
    overflow: auto;
    padding: 0;
    margin: 0;
    box-sizing: border-box;
  }
  .no-scroll {
    overflow: hidden;
  }
  .card {
    transition: all 0.3s ease-in-out;
  }

  @media (max-width: 767px) {
    .chart-wrapper {
        height: auto;
    }
  }
  </style>
  